import { cn } from '@/shared/lib/cn';

/** Mehrfachauswahl als Chips (Board „Verlauf eingrenzen“); keiner gewählt heißt „alle“. */
export function HistoryChoiceChips({
  title,
  options,
  labels,
  value,
  onChange,
}: {
  title: string;
  options: readonly string[];
  /** Wort je Wert. */
  labels: Record<string, string>;
  value: string[];
  onChange: (value: string[]) => void;
}) {
  return (
    <fieldset className="flex flex-col gap-1.5">
      <legend className="mb-1.5 text-xs font-bold">{title}</legend>
      <div className="flex flex-wrap gap-1.5">
        {options.map((option) => {
          const on = value.includes(option);
          return (
            <button
              key={option}
              type="button"
              aria-pressed={on}
              onClick={() =>
                onChange(on ? value.filter((entry) => entry !== option) : [...value, option])
              }
              className={cn(
                'rounded-pill flex min-h-11 items-center px-3 text-xs font-bold md:min-h-8',
                on ? 'bg-ink text-white' : 'border-line text-ink border',
              )}
            >
              {labels[option] ?? option}
            </button>
          );
        })}
      </div>
    </fieldset>
  );
}
